// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `::ng-deep div.background {
  position: relative;
  width: 100%;
}
::ng-deep div.background:before {
  content: "";
  position: absolute;
  background-size: contain;
  background-image: url("/assets/images/rooftop-solar-grid.jpeg");
  background-repeat: no-repeat;
  background-position: left top;
  width: 100%;
  height: 100%;
  min-height: 475px;
  z-index: 1;
}
::ng-deep ul.disc {
  list-style-type: disc;
  margin-bottom: 1rem;
}
::ng-deep ul.disc li {
  margin-left: 2rem;
  margin-bottom: 0.5rem;
}`, "",{"version":3,"sources":["webpack://./src/app/secure/secure.component.scss"],"names":[],"mappings":"AACI;EACI,kBAAA;EACA,WAAA;AAAR;AAEQ;EACI,WAAA;EACA,kBAAA;EACA,wBAAA;EACA,+DAAA;EACA,4BAAA;EACA,6BAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,UAAA;AAAZ;AAII;EACI,qBAAA;EACA,mBAAA;AAFR;AAIQ;EACI,iBAAA;EACA,qBAAA;AAFZ","sourcesContent":["::ng-deep {\n    div.background {\n        position: relative;\n        width: 100%;\n\n        &:before {\n            content:\"\";\n            position: absolute;\n            background-size: contain;\n            background-image: url('/assets/images/rooftop-solar-grid.jpeg');\n            background-repeat: no-repeat;\n            background-position: left top;\n            width: 100%;\n            height: 100%;\n            min-height: 475px;\n            z-index: 1;\n        }\n    }\n\n    ul.disc {\n        list-style-type: disc;\n        margin-bottom: 1rem;\n\n        li {\n            margin-left: 2rem;\n            margin-bottom: .5rem;\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
